import { styled } from '@glitz/react';

export const absoluteCenterDecorator = styled({
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
});

export const verticalCenterDecorator = styled({
  position: 'absolute',
  top: '50%',
  transform: 'translate(0, -50%)',
});

export const horizontallyCenterDecorator = styled({
  position: 'absolute',
  left: '50%',
  transform: 'translate(-50%, 0)',
});
